// extracted by mini-css-extract-plugin
var _1 = "MFE1mQ1TJnZyO131WZHb";
var _2 = "dnoafIg4v_Ub6yx7itHh";
var _3 = "TuHRc9gKO_sp7eYTHjqQ";
var _4 = "#000000";
var _5 = "#76F366";
var _6 = "#EB8632";
var _7 = "#ECC834";
var _8 = "#21FC87";
var _9 = "#EA4A30";
var _a = "#C7EA45";
var _b = "#272B2B";
var _c = "#BDBDBD";
var _d = "#7D7D7D";
var _e = "#6A0DAD";
var _f = "#3A65FF";
var _10 = "#4A90E2";
var _11 = "#ffffff";
var _12 = "IBzSHIGzRPyI_avPLKQR";
var _13 = "UpcEwNNWTMRQEeFV_t78";
var _14 = "1200px";
var _15 = "992px";
var _16 = "1366px";
var _17 = "768px";
var _18 = "1475px";
var _19 = "576px";
var _1a = "1600px";
var _1b = "320px";
var _1c = "2500px";
var _1d = "BZtChCgUupywVv15srL2";
var _1e = "SC8N2URkBMZpX9d9t30n";
var _1f = "a2ZOnPvUNa38OVa1E_kk";
var _20 = "LUrJhAegZjl41dC23KQU";
var _21 = "KmV3o_qDI3rpY8R_AXMA";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "clockIcon", _4 as "colorBlack", _5 as "colorGradeEX", _6 as "colorGradeFR", _7 as "colorGradeGD", _8 as "colorGradeOU", _9 as "colorGradePR", _a as "colorGradeVG", _b as "colorNeutral", _c as "colorNeutralLighest", _d as "colorNeutralLight", _e as "colorNonOwnerSweetLine", _f as "colorOwnerSweetLine", _10 as "colorRegularLinks", _11 as "colorWhite", _12 as "moreIcon", _13 as "reset-button", _14 as "screenlg", _15 as "screenmd", _16 as "screenml", _17 as "screensm", _18 as "screenxlg", _19 as "screenxs", _1a as "screenxxlg", _1b as "screenxxs", _1c as "screenxxxlg", _1d as "single-page-responsive-font-size", _1e as "tab", _1f as "tabs", _20 as "tabsContainer", _21 as "title" }
export default { "active-media-preview": _1, "base-link": _2, "clockIcon": _3, "colorBlack": _4, "colorGradeEX": _5, "colorGradeFR": _6, "colorGradeGD": _7, "colorGradeOU": _8, "colorGradePR": _9, "colorGradeVG": _a, "colorNeutral": _b, "colorNeutralLighest": _c, "colorNeutralLight": _d, "colorNonOwnerSweetLine": _e, "colorOwnerSweetLine": _f, "colorRegularLinks": _10, "colorWhite": _11, "moreIcon": _12, "reset-button": _13, "screenlg": _14, "screenmd": _15, "screenml": _16, "screensm": _17, "screenxlg": _18, "screenxs": _19, "screenxxlg": _1a, "screenxxs": _1b, "screenxxxlg": _1c, "single-page-responsive-font-size": _1d, "tab": _1e, "tabs": _1f, "tabsContainer": _20, "title": _21 }
